module.exports = __webpack_public_path__ + "static/media/sidebar_private_blue.df6c74b6.svg";